import { usePage } from "@inertiajs/react"
import type { AuthShare, CompanyPermissions } from "@/types/auth"
import type { ProjectPermissions } from "@/types/workspace"

export type { CompanyPermissions } from "@/types/auth"

type PermissionsPageProps = {
  auth?: AuthShare
  project_permissions?: ProjectPermissions
}

const NO_PERMISSIONS: CompanyPermissions = {
  can_create_projects: false,
  can_manage_members: false,
  can_manage_company_settings: false,
  can_view_monitoring: false,
}

export function usePermissions(): CompanyPermissions {
  const page = usePage<PermissionsPageProps>()
  return page.props.auth?.permissions ?? NO_PERMISSIONS
}

export function useProjectPermissions(): ProjectPermissions | null {
  const page = usePage<PermissionsPageProps>()
  return page.props.project_permissions ?? null
}

export function useAuth(): AuthShare | null {
  const page = usePage<PermissionsPageProps>()
  return page.props.auth ?? null
}
